import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { doc, docData, DocumentReference, Firestore } from '@angular/fire/firestore';
import { Subscription } from 'rxjs';
import { map, distinctUntilChanged, filter } from 'rxjs/operators';
import { ITableState } from '@soposopo/sopo-models';
import { ChatUserInfoDispatcher } from 'src/app/core/state/chatUserInfo/chatUserInfo.dispatcher';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';

@Component({
    selector: 'app-waiting-player-item',
    templateUrl: './waiting-player-item.page.html',
    styleUrls: ['./waiting-player-item.page.scss'],
    standalone: false
})
export class WaitingPlayerItem implements OnInit, OnDestroy {
    tableSubscription: Subscription;
    waitingPlayers: string[] = [];
    
    constructor(
        public firestore: Firestore,
        public sopoDialogRef: SopoDialogRef,
        public chatUserInfoDispather: ChatUserInfoDispatcher,
        @Inject(SOPO_DIALOG_DATA) public data: {tableId: string},
    ) {}

    ngOnInit() {
        this.init();
    }

    async init() {
        if (!this.data) return;
        const tableId = this.data.tableId;
        const docReference = doc(this.firestore, `tables/${tableId}`) as DocumentReference<ITableState>;
        this.tableSubscription = docData<ITableState>(docReference)
        .pipe(
            filter(tableData => !!tableData),
            map(tableData => tableData.waitingList),
            distinctUntilChanged((prev, curr) => prev.length === curr.length),
        )
        .subscribe(async (waitingList) => {
            const players = waitingList;
            if (players.length > this.waitingPlayers.length) {
                for(const playerId of players) {
                    if (!this.waitingPlayers.some(userId => userId === playerId)){
                        this.waitingPlayers.push(playerId);
                        this.chatUserInfoDispather.requestForChatUserInfos([playerId]);
                    }
                }
            } else if (players.length < this.waitingPlayers.length) {
                for(const waitingPlayer of this.waitingPlayers){
                    if(players.findIndex(playerId => playerId === waitingPlayer) === -1){                  
                        this.waitingPlayers.splice(this.waitingPlayers.indexOf(waitingPlayer), 1);
                        this.chatUserInfoDispather.clearRequestForChatUserInfos([waitingPlayer]);
                    }
                }
            } 
        });
    }

    displayPosition(position: number) {
        return 'is at ' + Number(position + 1);
    }

    dismiss() {
        this.sopoDialogRef.close();
    }

    ngOnDestroy(): void {
        if (this.tableSubscription) this.tableSubscription.unsubscribe();
        this.chatUserInfoDispather.clearRequestForChatUserInfos(this.waitingPlayers);
    }
}
